import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import styled from 'styled-components';

const StyledFormGroup = styled(Form.Group)`
  margin-bottom: 1.25rem;

  .form-label {
    font-weight: 500;
    color: #495057;
    margin-bottom: 0.5rem;
  }

  .form-control {
    border-radius: 8px;
    padding: 0.5rem 0.75rem;
    border: 1px solid #e0e0e0;
    transition: all 0.3s ease;

    &:focus {
      border-color: #4b6cb7;
      box-shadow: 0 0 0 0.25rem rgba(75, 108, 183, 0.25);
    }

    &.is-invalid {
      border-color: #dc3545;
    }
  }
`;

const ContactInformation = ({ register, errors }) => (
    <>
        <h5 className="section-title">Contact Information</h5>
        <Row>
            <StyledFormGroup as={Col} md="6">
                <Form.Label>Email <span className="text-danger">*</span></Form.Label>
                <Form.Control
                    type="email"
                    {...register('email')}
                    isInvalid={!!errors.email}
                    placeholder="example@gmail.com"
                />
                <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    {errors.email?.message}
                </Form.Control.Feedback>
            </StyledFormGroup>

            <StyledFormGroup as={Col} md="6">
                <Form.Label>Contact Number <span className="text-danger">*</span></Form.Label>
                <Form.Control
                    type="tel"
                    {...register('contact')}
                    isInvalid={!!errors.contact}
                    placeholder="98XXXXXXXX"
                />
                <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    {errors.contact?.message}
                </Form.Control.Feedback>
            </StyledFormGroup>
        </Row>
    </>
);

export default ContactInformation;